import React from "react"
import {useTranslation} from "react-i18next"
import {IonAccordion, IonInput, IonInputPasswordToggle, IonItem, IonToggle} from "@ionic/react"

import User      from "@customTypes/User"
import {useUsers as useItems} from "../../../contexts/UserContext"
import {AuthType} from "@customTypes/Auth"

interface componentProps {
    authUserInfo:      AuthType | undefined | null
    formData:          User
    setFormData:       React.Dispatch<React.SetStateAction<User>>
    updateFormHandler: any
}

export const AccordionUser: React.FC<componentProps> = ({
    authUserInfo, formData, setFormData, updateFormHandler
}) => {

    const { t } = useTranslation()
    const { inProgress } = useItems()

    return (
        <IonAccordion toggleIconSlot="start" value="user">
            <IonItem className="bc-accordion" slot="header">
                {t('users.title_item')}
            </IonItem>
            <IonItem slot="content">
                <IonToggle checked={formData.isEnabled}
                           color="success"
                           disabled={inProgress || authUserInfo?.user.id === formData.id}
                           justify="space-between" name="isEnabled" labelPlacement="start"
                           onIonChange={(e) => {
                               setFormData({ ...formData, ['isEnabled']: e.target.checked })
                           }}
                           value="1">
                    {t('users.form.is_enabled')}
                </IonToggle>
            </IonItem>
            {authUserInfo?.user.isAdmin !== false && formData.id === 0 &&
                <IonItem slot="content">
                    <IonToggle checked={formData.isAdmin} color="bc-yellow" disabled={inProgress}
                               justify="space-between" name="isAdmin" labelPlacement="start"
                               onIonChange={(e) => {
                                   setFormData({ ...formData, ['isAdmin']: e.target.checked })
                               }}
                               value="1">
                        {t('users.form.is_admin')}
                    </IonToggle>
                </IonItem>
            }
            <IonItem slot="content">
                <IonInput name="name" type="text"
                          label={t('users.form.name') as string} labelPlacement="stacked"
                          value={formData.name}
                          minlength={2} maxlength={128}
                          placeholder={t('users.form.name') as string}
                          clearInput={true}
                          autofocus={true}
                          required
                          disabled={inProgress}
                          tabIndex={1}
                          onIonChange={updateFormHandler('name')}
                />
            </IonItem>
            <IonItem slot="content">
                <IonInput name="email" type="email"
                          inputmode="email"
                          autocomplete="new-password"
                          autocorrect="off"
                          label={t('users.form.email') as string} labelPlacement="stacked"
                          value={formData.email}
                          minlength={2} maxlength={128}
                          placeholder={t('users.form.email_placeholder') as string}
                          clearInput={true}
                          disabled={inProgress}
                          tabIndex={2}
                          onIonChange={updateFormHandler('email')}
                />
            </IonItem>
            <IonItem slot="content">
                <IonInput name="password" type="password"
                          autocomplete="new-password"
                          autocorrect="off"
                          label={t('users.form.password') as string} labelPlacement="stacked"
                          value={formData.password}
                          minlength={2} maxlength={128}
                          placeholder={t('users.form.password') as string}
                          clearInput={true}
                          disabled={inProgress}
                          tabIndex={3}
                          onIonChange={updateFormHandler('password')}
                >
                    <IonInputPasswordToggle slot="end"></IonInputPasswordToggle>
                </IonInput>
            </IonItem>
        </IonAccordion>
    )

}

export default AccordionUser